import TableSkeleton from "@/app/components/ui/Skeletons/TableSkeleton";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICalendarState } from "@/app_redux/reducers/slices/auth/staff_calendar_slice";
import { CalendarIcon, TicketIcon } from "@heroicons/react/24/outline";

const CalendarGridViewComponent = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("STAFF_CALENDAR", "id"));
  const { calendarData } = routeState.state as ICalendarState;

  return (
    <ul role="list" className="grid grid-cols-1 gap-4 pb-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
      {calendarData ? (
        calendarData.map((staff) => (
          <li key={staff?.staff_id} className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow">
            <div className="flex w-full items-center justify-between space-x-4 p-4 sm:space-x-6 sm:p-6">
              <div className="flex-1 truncate">
                <div className="flex items-center space-x-3">
                  <h3 className="truncate text-sm font-medium text-gray-900">{staff?.staff_name}</h3>
                  <span className="inline-flex flex-shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                    {"Doctor"}
                  </span>
                </div>
                <p className="font-semibold text-xs mt-3">Staff Schedule</p>
                <p className="mt-1 truncate text-sm text-gray-500">{staff?.staff_schedule}</p>
              </div>
              <img className="h-10 w-10 flex-shrink-0 rounded-full bg-gray-300" src={staff?.image_url} alt="" />
            </div>
            <div>
              <div className="-mt-px flex divide-x divide-gray-200">
                <div className="flex w-0 flex-1">
                  <a
                    href={`mailto:`}
                    className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-2 rounded-bl-lg border border-transparent py-3 text-xs font-semibold text-gray-900 sm:gap-x-3 sm:py-4 sm:text-sm"
                  >
                    <CalendarIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    Today's Booking
                  </a>
                </div>
                <div className="-ml-px flex w-0 flex-1">
                  <a
                    href={`tel:`}
                    className="relative inline-flex w-0 flex-1 items-center justify-center gap-x-2 rounded-br-lg border border-transparent py-3 text-xs font-semibold text-gray-900 sm:gap-x-3 sm:py-4 sm:text-sm"
                  >
                    <TicketIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    Booking Details
                  </a>
                </div>
              </div>
            </div>
          </li>
        ))
      ) : (
        <TableSkeleton />
      )}
    </ul>
  );
};

export default CalendarGridViewComponent;
